<template>
  <ModalConfirmation
    :title="type === 'at_work' ? 'Вы действительно хотите принять партию в работу?' : 'Вы действительно хотите вернуть партию в ожидание?'"
    text-btn-reject="Отмена"
    @confirm="requestHandler()"
    @reject="onReject"
  />
</template>

<script>
import ModalConfirmation from '@/components/ui/Modal/ModalConfirmation'
import ConsignmentController from '@/controllers/production/Consignment/ConsignmentController'

export default {
  name: 'ModalConsignmentWorkTime',
  components: {
    ModalConfirmation
  },
  props: {
    consignment: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'at_work'
    }
  },

  methods: {
    // Принимаем партию в работу или отправляем в ожидание в зависимости от типа
    async requestHandler () {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')
        const data = {
          type: this.type
        }
        const response = await ConsignmentController.workTime(this.consignment.id, data)
        if (response?.status !== 200) return

        this.$emit('workTime', response.data)
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },

    onReject () {
      this.$emit('close')
    }
  }
}
</script>
